import './App.css';
import { AllRoutes } from './Netmeds/AllRoutes';


function App() {



  return (
    <div className="App">
        <AllRoutes/>
    </div>
  );
}

export default App;
